export default () => {
    window.addEventListener('load', () => {
        setTimeout(() => {
            const url = new URL(window.location)
            url.searchParams.delete('_gl')
            history.replaceState(null, '', url)
        }, 500)
    })
}
